module.exports = __webpack_public_path__ + "static/media/header-image.99f47dcc.png";